import ApiService from "../../utils/fetch";

const sopUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/user-access`;

export const raiseSopAccessRequest = async (payload) => {
  const response = await ApiService.post(`${sopUrl}/raise-sop-access-request`, payload);
  return response.data;
};

// Reusable roles endpoint for screens that need to filter by role type.
export const getSopRolesByApplicationTypeAndRoleType = async (applicationType, roleType) => {
  const response = await ApiService.get(`${sopUrl}/roles`, { applicationType, roleType });
  return response?.data || {};
};

// Backward-compatible wrapper for callers that only need roles by application type.
export const getSopRolesByApplicationType = async (applicationType) => {
  const data = await getSopRolesByApplicationTypeAndRoleType(applicationType);
  const roles = data?.roles;
  if (Array.isArray(roles)) return roles;
  if (Array.isArray(data)) return data;
  return roles ? [roles] : [];
};

export const getSopAdditionalPermissionsByApplicationType = async (applicationType) => {
  const response = await ApiService.get(`${sopUrl}/additionalPermissions`, { applicationType });
  const data = response?.data;

  return Array.isArray(data) ? data : [];
};

export const getDomainList = async () => {
  const response = await ApiService.get(`domains`);
  return response.data;
};

export const getDomainDashboardSummary = async () => {
  const response = await ApiService.get(`domains/dashboard-summary`);
  return response.data;
};

export const addDomain = async (data) => {
  const response = await ApiService.post(`domains/add-domain`, data);
  return response.data;
};

export const uploadDomain = async (formData) => {
  const response = await ApiService.post(`domains/upload`, formData, {}, { meta: { suppressToast: true } });
  return response.data;
};

export const whitelistDomains = async (payload) => {
  const response = await ApiService.post(`domains/whitelist`, payload);
  return response.data;
};

export const blacklistDomains = async (payload) => {
  const response = await ApiService.post(`/domains/blacklist`, payload);
  return response.data;
};
